module.exports = __webpack_public_path__ + "static/media/aspect.9a1f9548.jpg";